<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex>
        <v-row class="fill-height" no-gutters>
          <v-col class="col-12">
            <v-row>
              <v-col class="col-12">
                <v-card-title class="mb-4">
                  <v-row>
                    <v-col class="col-6 col-md-5">
                      <h1 class="primary-color">Users</h1>
                    </v-col>
                    <v-spacer />
                    <v-col v-if="canRegisterUsers" class="col-6 col-md-2">
                      <v-btn class="new-item-btn float-right" block @click="openRegisterForm">
                        <v-icon size="20">mdi-plus</v-icon>
                        &nbsp;&nbsp;Register new user
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-title>

                <v-data-table
                  :headers="headers"
                  :items="users"
                  item-key="id"
                  :loading="loading"
                  loading-text="Loading... Please, wait"
                  :server-items-length="pagination.totalItems"
                  :items-per-page="pagination.itemsPerPage"
                  :page.sync="pagination.page"
                  item-class="text-wrap"
                  @update:page="handlePageChange"
                >
                  <template #[`item.username`]="{ item }">
                    {{ item.username }}
                  </template>
                  <template #[`item.email`]="{ item }">
                    {{ item.email }}
                  </template>
                  <template #[`item.createdAt`]="{ item }">
                    {{ item.createdAt | formatDate }}
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
            <v-alert
              v-if="messageRegisterSucceed"
              outlined
              :color="successfullRegisterSucceed ? 'success' : 'error'"
              :icon="successfullRegisterSucceed ? 'mdi-check-circle' : 'mdi-alert'"
              dismissible
            >
              {{ messageRegisterSucceed }}
            </v-alert>
            <v-alert
              v-if="messageUsers"
              class="mt-4"
              outlined
              :color="successfullUsers ? 'success' : 'error'"
              :icon="successfullUsers ? 'mdi-check-circle' : 'mdi-alert'"
              dismissible
            >
              {{ messageUsers }}
            </v-alert>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>

    <v-dialog v-model="registerUserDialog" max-width="500" persistent>
      <v-card>
        <v-form ref="registerUserForm" @submit.prevent="register">
          <v-card-title class="px-6">
            <h5 class="primary-color">Register User</h5>
          </v-card-title>
          <v-card-text class="mt-4 pb-0 px-6">
            <v-text-field
              v-model="user.username"
              class="py-0 mb-6 no-border-radius"
              label="Username"
              :rules="[usernameRules.required]"
              dense
              type="text"
            />
            <v-text-field
              v-model="user.email"
              class="py-0 mb-6 no-border-radius"
              label="Email"
              :rules="[emailRules.required, emailRules.email]"
              dense
              type="email"
            />

            <v-alert
              v-if="messageSignUp"
              outlined
              :color="successfullSignUp ? 'success' : 'error'"
              :icon="successfullSignUp ? 'mdi-check-circle' : 'mdi-alert'"
              dismissible
            >
              {{ messageSignUp }}
            </v-alert>
          </v-card-text>

          <v-card-actions class="pa-4">
            <v-spacer />
            <v-btn text class="cancel-modal" @click="cancelRegisterUser"> Cancel </v-btn>

            <v-btn v-if="!signingUp" type="submit" class="ok-modal" :disabled="!isValidSignUp">
              Sign up user
            </v-btn>
            <v-btn v-else color="primary" class="ok-modal" disabled>
              <v-progress-circular indeterminate color="primary" />
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import AuthDataService from '@/services/AuthDataService';
import UsersDataService from '@/services/UsersDataService';

export default {
  name: 'UsersList',
  data() {
    return {
      users: [],
      successfullUsers: false,
      messageUsers: '',
      successfullRegisterSucceed: false,
      messageRegisterSucceed: '',
      successfullSignUp: false,
      messageSignUp: '',
      loading: false,
      headers: [
        { text: 'Username', value: 'username', sortable: false },
        { text: 'Email', value: 'email', sortable: false },
        { text: 'Created at', value: 'createdAt', sortable: false },
      ],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        totalPages: 1,
        totalItems: 0,
      },
      registerUserDialog: false,
      user: {
        username: '',
        email: '',
      },
      signingUp: false,
      emailRules: {
        required: (v) => !!v || 'Required field',
        email: (v) => /.+@.+\..+/.test(v) || 'Invalid email address',
      },
      usernameRules: {
        required: (v) => !!v || 'Required field',
      },
      canRegisterUsers: true,
    };
  },
  computed: {
    isValidSignUp() {
      return (
        this.user.email !== '' &&
        this.user.username !== '' &&
        this.emailRules.email(this.user.email) !== 'Invalid email address'
      );
    },
  },
  watch: {},
  async mounted() {
    this.canRegisterUsers = JSON.parse(localStorage.getItem('user')).canRegisterUsers;

    await this.getAllUsers(1);
  },
  methods: {
    getAllUsers(page) {
      this.loading = true;

      UsersDataService.findAll(page, this.pagination.itemsPerPage).then(
        (response) => {
          if (response.status == 200) {
            this.users = response.data.data;

            if (this.users.length !== 0) {
              this.pagination.page = page;
              this.pagination.totalPages = response.data.links.totalPages || 1;

              this.pagination.totalItems =
                response.data.links.totalItems ||
                this.pagination.totalPages * this.pagination.itemsPerPage;
            }
          } else {
            this.successfullUsers = false;
            this.messageUsers =
              'An error has occurred retrieving the list of users. Please, try again later.';
          }

          this.loading = false;
        },
        (error) => {
          this.successfullUsers = false;
          this.messageUsers =
            'An error has occurred retrieving the list of users. Please, try again later.';

          console.error(
            (error.response && error.response.data) || error.message || error.toString()
          );

          if (error.response.status === 401 || error.response.status === 403) {
            localStorage.removeItem('user');
            this.$router.push('/');
          }

          this.loading = false;
        }
      );
    },
    handlePageChange(newPage) {
      this.pagination.page = newPage;
      this.getAllUsers(newPage);
    },
    openRegisterForm() {
      this.user.username = '';
      this.user.email = '';
      this.registerUserDialog = true;
    },
    cancelRegisterUser() {
      this.user.username = '';
      this.user.email = '';
      this.registerUserDialog = false;
    },
    register() {
      this.messageSignUp = '';
      this.successfullSignUp = false;
      this.messageRegisterSucceed = '';
      this.successfullRegisterSucceed = false;
      this.signingUp = true;

      AuthDataService.register(this.user.email, this.user.username).then(
        (response) => {
          if (response.status == 201) {
            this.getAllUsers(1);
            this.registerUserDialog = false;
            this.successfullRegisterSucceed = true;
            this.messageRegisterSucceed =
              'Sign up successfully completed. Please tell the user to check his or her email inbox to confirm the account and login.';
          } else {
            this.successfullSignUp = false;
            this.messageSignUp = 'An error occurred while signing up. Please, try again later.';
          }

          this.signingUp = false;
        },
        (error) => {
          this.successfullSignUp = false;
          console.error(
            (error.response && error.response.data) || error.message || error.toString()
          );

          if (error.response.status == 409) {
            if (error.response.data.error == 'EMAIL_ALREADY_EXISTS') {
              this.messageSignUp = 'Email already in use. Please, provide another one.';
            } else if (error.response.data.error == 'USERNAME_ALREADY_EXISTS') {
              this.messageSignUp = 'Username already in use. Please, provide another one.';
            } else {
              this.messageSignUp = 'An error occurred while signing up. Please, try again later.';
            }
          } else if (error.response.status == 403) {
            this.messageSignUp = 'You do not have permission to register users.';
          } else if (error.response.status === 401) {
            localStorage.removeItem('user');
            this.$router.push('/');
          } else {
            this.messageSignUp = 'An error occurred while signing up. Please, try again later.';
          }

          this.signingUp = false;
        }
      );
    },
  },
};
</script>
